const NoResultFoundStyles = () => ({
    noResultFound: {
        // height: "100%",
        '& .MuiTypography-root': {
            marginTop: '15px',
            color: 'gray'
        }
    }
});
export default NoResultFoundStyles;